// extracted by mini-css-extract-plugin
export default {"queries":"queries_queries__iQpUb","container":"queries_container__EPgOr","card":"queries_card__RL17f","queryImage":"queries_queryImage__RB0hc"};